import { Typography } from "@mui/material";
import { memo, useState } from "react";

function AppTile({ label, image, onClick }) {
  const [pressed, setPressed] = useState(false);

  return (
    <div
      onClick={onClick}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setPressed(false)}
      style={{
        textAlign: "center",
        cursor: "pointer",
        padding: "0.5rem",
        borderRadius: "12px",

        // ✅ smooth animation
        transform: pressed ? "scale(0.95)" : "scale(1)",
        transition: "all 0.2s ease",

        // ✅ hover (desktop)
        boxShadow: pressed
          ? "0 2px 6px rgba(0,0,0,0.2)"
          : "0 4px 10px rgba(0,0,0,0.1)",

        // ✅ nicer hover highlight
        backgroundColor: pressed ? "#f5f5f5" : "transparent",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "110px", // ✅ slightly bigger → better touch
          height: "110px",
          borderRadius: "50%",
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",

          // ✅ nice shadow
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",

          transition: "transform 0.2s ease",
        }}
      />

      <Typography
        color="textSecondary"
        variant="subtitle1" // ✅ better on small screens than h6
        style={{
          marginTop: "0.6rem",
          fontWeight: 500,
        }}
      >
        {label}
      </Typography>
    </div>
  );
}

export default memo(AppTile);
